import React, { useEffect, useState } from 'react';
import Select from '@truescope-web/react/lib/components/form/Select';
import ValidationPlaceholder from '@truescope-web/react/lib/components/form/ValidationPlaceholder';
import Grid from '@truescope-web/react/lib/components/layout/Grid';
import Typography from '@truescope-web/react/lib/components/layout/Typography';
import { useConfigContext } from '../../../components/Config/ConfigProvider';
import { updateDashboardBuilderState } from './DashboardBuilderReducer';

const FilterStep = ({ state, dispatch, validationState }) => {
	const [queryOptions, setQueryOptions] = useState([]);
	const [{ workspace }] = useConfigContext();

	useEffect(() => {
		setQueryOptions(
			workspace.queries.filter((query) => !query.is_paused).map((query) => ({ label: query.name, value: query.query_id }))
		);
	}, [workspace]);

	return (
		<Grid container>
			<Grid item>
				<Typography variant="subtitle">Choose which query to analyze on this Dashboard</Typography>
			</Grid>
			<Grid item>
				<Select
					options={queryOptions}
					onChange={(_e, value) =>
						dispatch(
							updateDashboardBuilderState({
								defaultFilters: {
									...state.defaultFilters,
									query_ids: value
								}
							})
						)
					}
					value={state?.defaultFilters?.query_ids}
					isMulti
					menuPosition="fixed"
				/>
			</Grid>
			<Grid item>
				<ValidationPlaceholder validationResult={validationState?.results?.query_ids} />
			</Grid>
		</Grid>
	);
};

export default FilterStep;
